import React from 'react';
import Star from '@lt/components/icons-react/userflow/Star';
import styles from './hotelCardStars.module.css';

type HotelCardStarsProps = {
  value: number;
};

const HotelCardStars: React.FC<HotelCardStarsProps> = ({ value }) => {
  if (!value) return null;

  const starsArr = Array.from({ length: value }, (_, index) => index);

  return (
    <>
      <div className={styles.starsContainer}>
        {starsArr.map((el) => (
          <Star key={el} className={styles.starIcon} />
        ))}
      </div>
    </>
  );
};

export default HotelCardStars;
